// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkBox_link__1dKWV"};